import XCloseIcon from "@redotech/redo-icons/x-close.svg";
import { SlideInPanelAnchorLocation } from "@redotech/redo-model/slide-in-panel/slide-in-panel-anchor-location";
import { IconButton } from "@redotech/redo-web/button";
import { Flex } from "@redotech/redo-web/flex";
import { assertNever } from "@redotech/util/type";
import classNames from "classnames";
import { memo, useMemo } from "react";
import * as slideInPanelCss from "./slide-in-panel.module.css";

export const SlideInPanel = memo(function SlideInPanel({
  children,
  anchorLocation,
  open,
  handleCloseClick,
}: {
  children: React.ReactNode | React.ReactNode[];
  anchorLocation: SlideInPanelAnchorLocation;
  open: boolean;
  handleCloseClick: () => void;
}) {
  const _anchorLocation = useMemo(() => {
    switch (anchorLocation) {
      case SlideInPanelAnchorLocation.BOTTOM_LEFT:
        return slideInPanelCss.bottomLeft;
      case SlideInPanelAnchorLocation.BOTTOM_RIGHT:
        return slideInPanelCss.bottomRight;
      case SlideInPanelAnchorLocation.TOP_LEFT:
        return slideInPanelCss.topLeft;
      case SlideInPanelAnchorLocation.TOP_RIGHT:
        return slideInPanelCss.topRight;
      default:
        assertNever(anchorLocation);
    }
    // FIXME
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return open ? (
    <Flex
      className={classNames(slideInPanelCss.panelContainer, _anchorLocation)}
    >
      <IconButton
        className={slideInPanelCss.closeIconButton}
        onClick={handleCloseClick}
      >
        <XCloseIcon />
      </IconButton>
      {children}
    </Flex>
  ) : null;
});
